import styled from 'styled-components';
import { TileWidth } from '@/vdp/VehiclesYouMightLike/VehicleTile/VehicleTile.styles';
import HeartWithBorder from '~/icons/HeartWithBorder';

export const Grid = styled.div.attrs({
  className: 'grid'
})`
  grid-template: 1fr / 1fr;

  a {
    grid-column: 1;
    grid-row: 1;
    border-radius: 6px 6px 0 0;
  }
`;

export const Heart = styled(HeartWithBorder).attrs({
  className: 'm-12 pointer-events-auto'
})`
  height: 18px;
  width: 20px;

  .svg-heart {
    stroke: var(--cvna-color-blue-2);
  }
`;

export const Image = styled.img.attrs({
  className: 'object-cover'
})`
  border-radius: 6px 6px 0 0;
  width: ${TileWidth}px;
  max-height: 177px;
`;

export const Overlay = styled.div.attrs({
  className: 'flex justify-between pointer-events-none'
})`
  z-index: 1;
  grid-column: 1;
  grid-row: 1;
`;
